import { Schema as S } from "effect";
import * as AppStore from "./app-store";
import * as Paddle from "./paddle";
import * as PlayStore from "./play-store";
import * as Stripe from "./stripe";
export { AppStore, Paddle, PlayStore, Stripe };
export const Schema = S.Union(Stripe.Schema, Paddle.Schema, AppStore.Schema, PlayStore.Schema);
